'use client'

import type { Space } from '@cocoonspace/sdk-js/types/space'
import {
	createContext,
	useContext,
	useEffect,
	useRef,
	useState,
	type ReactNode,
} from 'react'
import { useInView } from 'motion/react'

import { SpaceDetailsNav } from './space-details-nav'
import { SpaceDetailsSidebarSkeleton } from './space-details-sidebar-skeleton'
import { SpaceDetailsSidebar } from './space-details-sidebar/sidebar'

const HeroInViewContext = createContext(true)
const SetHeroInViewContext = createContext<(value: boolean) => void>(() => {})

export const SpaceDetailsHeroInViewProvider = ({
	children,
}: {
	children: ReactNode
}) => {
	const [isHeroInView, setIsHeroInView] = useState(true)

	return (
		<SetHeroInViewContext.Provider value={setIsHeroInView}>
			<HeroInViewContext.Provider value={isHeroInView}>
				{children}
			</HeroInViewContext.Provider>
		</SetHeroInViewContext.Provider>
	)
}

export const SpaceDetailsHeroInViewSentinel = ({
	children,
}: {
	children: ReactNode
}) => {
	const setIsHeroInView = useContext(SetHeroInViewContext)
	const ref = useRef<HTMLDivElement>(null)
	const isInView = useInView(ref, { margin: '-130px 0px 0px 0px' })

	useEffect(() => {
		setIsHeroInView(isInView)
	}, [isInView, setIsHeroInView])

	return <div ref={ref}>{children}</div>
}

export const SpaceDetailsNavGate = ({ spaceTitle }: { spaceTitle: string }) => {
	const isHeroInView = useContext(HeroInViewContext)

	if (isHeroInView) return null

	return <SpaceDetailsNav spaceTitle={spaceTitle} />
}

export const SpaceDetailsSidebarHole = ({ space }: { space: Space }) => {
	const isHeroInView = useContext(HeroInViewContext)
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
	}, [])

	if (!mounted) {
		return <SpaceDetailsSidebarSkeleton />
	}

	return (
		<SpaceDetailsSidebar
			showInfoCard={isHeroInView}
			space={space}
		/>
	)
}
